<template>
  <div class="add-user-port-window">
    <el-dialog
      ref="dialog"
      v-el-drag-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      :title="$t('SystemMaintenance.PositionAssociatedRoutePortConfig')"
      width="970px"
      @close="removeHandler"
    >
      <div class="flex-column">
        <div>
          <span class="title">{{ $t('SystemMaintenance.MatchingCriteriaSelection') }}</span>
        </div>
        <el-form label-width="100px" inline style="margin-top: 5px;">
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.opOffice') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Office_All"
              filterable
              :multiple="true"
              :static-options="officeList"
              :default-multiple-value="toNumArray(saveData.multipleOpOffice)"
              tag-name="code"
              style="width: 200px"
              @parentCallBack="p=>{saveData.multipleOpOffice=toTxt(p.value);onRelatedPrivilegeChange()}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_BusinessType') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
              :static-options="lobs"
              :show-custom-label-in-option="true"
              :default-value="saveData.lob"
              style="width: 200px"
              :clearable="false"
              @parentCallBack="p=>{ddlLobChangeHandler(p.value);onRelatedPrivilegeChange()}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_BusinessModel') }}</div>
            <cargo-advance-select
              filterable
              :multiple="true"
              :placeholder="' '"
              callback-method-type="value"
              :static-options="operateTypeList"
              :default-multiple-value="saveData.operateTypeList"
              tag-name="chineseName"
              tag-value="code"
              style="width:200px;"
              @parentCallBack="value=>{saveData.operateTypeList=[...value];onOperateTypeChange()}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CustomJobType') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :multiple="true"
              :method-params="{type:saveData.lob, active: true}"
              :default-multiple-value="toArray(saveData.multipleCustomJobType)"
              style="width: 200px"
              @parentCallBack="p=>{saveData.multipleCustomJobType=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectARoute') }}</div>
            <cargo-advance-select
              v-if="isSea||isAir"
              :select-type="selectTypeNames.basic_data_Region"
              :static-options="isSea?seaRegionList:airRegionList"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(saveData.multipleRegion)"
              tag-name="name"
              style="width: 200px"
              @parentCallBack="onMultipleRegionChange"
            />
            <cargo-advance-select
              v-else
              :select-type="selectTypeNames.basic_data_RailwayLine"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(saveData.multipleRegion)"
              tag-name="name"
              style="width: 200px"
              @parentCallBack="p=>{saveData.multipleRegion=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <template>
              <div v-if="isAir" slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectLoadingPort') }}</div>
              <div v-else-if="isRailway" slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectOriginatingStation') }}</div>
              <div v-else slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectDeparturePort') }}</div>
            </template>
            <template>
              <cargo-advance-select
                v-if="isSea"
                :select-type="selectTypeNames.basic_data_Seaport"
                :static-options="portList"
                filterable
                :multiple="true"
                :callback-params="{key:'multipleLoadingPortCode'}"
                :default-multiple-value="toArray(saveData.multipleLoadingPortCode)"
                style="width: 200px"
                @parentCallBack="p=>{saveData[p.key]=toTxt(p.value)}"
              />
              <cargo-advance-select
                v-else-if="isAir"
                :select-type="selectTypeNames.basic_data_Airport"
                :static-options="portList"
                filterable
                :multiple="true"
                :callback-params="{key:'multipleLoadingPortCode'}"
                :default-multiple-value="toArray(saveData.multipleLoadingPortCode)"
                style="width: 200px"
                @parentCallBack="p=>{saveData[p.key]=toTxt(p.value)}"
              />
              <cargo-advance-select
                v-else
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :multiple="true"
                :callback-params="{key:'multipleLoadingPortCode'}"
                :default-multiple-value="toArray(saveData.multipleLoadingPortCode)"
                style="width: 200px"
                @parentCallBack="p=>{saveData[p.key]=toTxt(p.value)}"
              />
            </template>
          </el-form-item>
          <el-form-item>
            <template>
              <div v-if="isAir" slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_PortOfDestinationTip') }}</div>
              <div v-else-if="isRailway" slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectDestinationStation') }}</div>
              <div v-else slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_PortOfDischargeTip') }}</div>
            </template>
            <template>
              <cargo-advance-select
                v-if="isSea"
                :select-type="selectTypeNames.basic_data_Seaport"
                :static-options="portList"
                filterable
                :multiple="true"
                :callback-params="{key:'code'}"
                :default-multiple-value="toArray(saveData.code)"
                style="width: 200px"
                @parentCallBack="p=>{saveData[p.key]=toTxt(p.value)}"
              />
              <cargo-advance-select
                v-else-if="isAir"
                :select-type="selectTypeNames.basic_data_Airport"
                :static-options="portList"
                filterable
                :multiple="true"
                :callback-params="{key:'code'}"
                :default-multiple-value="toArray(saveData.code)"
                style="width: 200px"
                @parentCallBack="p=>{saveData[p.key]=toTxt(p.value)}"
              />
              <cargo-advance-select
                v-else
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :multiple="true"
                :callback-params="{key:'code'}"
                :default-multiple-value="toArray(saveData.code)"
                style="width: 200px"
                @parentCallBack="p=>{saveData[p.key]=toTxt(p.value)}"
              />
            </template>
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.CargoType') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CargoType"
              :method-params="isAir?{air:true}:{sea:true}"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(saveData.multipleCargoType)"
              style="width: 200px"
              @parentCallBack="p=>{saveData.multipleCargoType=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PleaseSelectCarrier') }}</div>
            <cargo-company-select
              v-if="saveData.lob === 'SE'"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(saveData.multipleCarrierId)"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="saveData.lob === 'SI'"
              :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(saveData.multipleCarrierId)"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="saveData.lob === 'AE'"
              :method-params="{companyLob:'airExport',airCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(saveData.multipleCarrierId)"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="saveData.lob === 'AI'"
              :method-params="{companyLob:'airImport',airCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(saveData.multipleCarrierId)"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleCarrierId=toTxt(p.value)}"
            />
            <cargo-company-select
              v-else-if="saveData.lob === 'IE' && saveData.operateType.indexOf('IC') > -1"
              :method-params="{companyLob:'integratedJob',truckCmp:true,active:true}"
              multiple
              :default-multiple-value="toNumArray(saveData.multipleCarrierId)"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleCarrierId=toTxt(p.value)}"
            />
            <el-select v-else disabled value placeholder=" " style="width: 200px" />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_PleaseSelectTheConsignee') }}</div>
            <cargo-company-select
              no="consigneeId"
              :method-params="{consignee:true,active:true}"
              multiple
              :default-multiple-value="saveData.multipleConsigneeIdList || []"
              :fields="['englishName']"
              tag-name="englishName"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleConsigneeIdList=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SeaExport.SolicitationType') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_CargoSource"
              filterable
              :multiple="true"
              :default-multiple-value="toArray(saveData.multipleCargoSource)"
              style="width: 200px"
              @parentCallBack="p=>{saveData.multipleCargoSource=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item v-if="['SE', 'AE'].includes(saveData.lob)">
            <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_DestinationAgent') }}</div>
            <cargo-company-select
              no="consigneeId"
              :method-params="{overseaAgent:true,active:true}"
              multiple
              :default-multiple-value="saveData.multipleDestinationAgentList || []"
              :fields="['englishName']"
              tag-name="englishName"
              custom-style="width: 200px"
              @change="p=>{saveData.multipleDestinationAgentList=p.value}"
            />
          </el-form-item>
        </el-form>
        <div style="width: calc(100% + 20px);margin-left: -10px;margin-top: 10px;margin-bottom: 10px;;border-top: 1px solid #E3E3E3;" />
        <div style="display: flex;">
          <div style="width: 350px;">
            <span class="title">{{ $t('SystemMaintenance.PresetValueConfiguration') }}</span>
          </div>
        </div>
        <el-form label-width="100px" inline style="margin-top: 5px;">
          <el-form-item>
            <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.RelatedUser') }}</div>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_User"
              callback-method-type="value"
              :default-value="saveData.userId"
              filterable
              style="width: 200px"
              :clearable="false"
              @parentCallBack="onUserIdChange"
            />
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="saveData.relatedPrivilege" @change="onRelatedPrivilegeChange">{{ $t('SystemMaintenance.OptionalPositionsRoles') }}</el-checkbox>
          </el-form-item>
        </el-form>
        <el-form v-for="(position, i) in positionData" :key="i" label-width="100px" inline>
          <el-form-item :label="i === 0 ? '' : ' '">
            <div v-if="i === 0" slot="label" style="text-align: center;">{{ $t('SystemMaintenance.ResponsiblePosition') }}</div>
            <el-select v-model="position.value" filterable clearable style="width: 200px" @change="onPositionChange(position)">
              <el-option v-for="(item,index) in roleList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="position.isDefault">{{ $t('CargoMsg.Cargo_DefaultValue') }}</el-checkbox>
            <span v-if="i === 0 && allRole.length > positionData.length" class="form-operator" @click="onAddPosition"><i class="el-icon-circle-plus" /></span>
            <span v-else class="form-operator" @click="onRemovePosition(position)"><i class="el-icon-remove" /></span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="onSave">{{ $t('SeaExport.Save') }}</el-button>
        <el-button @click="removeHandler">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { onSaveFunc } from '@/api/userPort'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import { SE, SI, AE, AI, RE, RI } from '@/class/cargo/model/parameters/SystemConstants'
import { getCacheListByKey, getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { checkUserPrivilege } from '@/api/privilege'
import CargoMultipleSelect from '@/components/Cargo/Common/CargoMultipleSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'AddUserPortWindow',
  components: { CargoAdvanceSelect, CargoMultipleSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    action: { type: String, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      lobs: [SE, SI, AE, AI, RE, RI],
      gridApi: null,
      operateTypeList: [],
      saveData: {
        uuid: '',
        userId: 0,
        code: '',
        lob: '',
        operateTypeList: [],
        operateType: '',
        multipleRegion: '',
        multipleCustomJobType: '',
        relatedPrivilege: false,
        multipleRole: '',
        multipleOpOffice: '',
        multipleLoadingPortCode: '',
        multipleCargoType: '',
        multipleCarrierId: '',
        multipleConsigneeId: '',
        multipleConsigneeIdList: null,
        multipleCargoSource: '',
        multipleDestinationAgent: '',
        multipleDestinationAgentList: null
      },
      positionData: [], // 岗位数据
      seaRegionList: [],
      airRegionList: [],
      portList: [],
      roleList: [],
      officeList: []
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    },
    isSea() {
      return this.saveData.lob === 'SE' || this.saveData.lob === 'SI'
    },
    isAir() {
      return this.saveData.lob === 'AE' || this.saveData.lob === 'AI'
    },
    isRailway() {
      return this.saveData.lob === 'RE' || this.saveData.lob === 'RI'
    },
    allRole() {
      return [
        { code: 'userDefinedRole1', name: this.$t('CargoMsg.Cargo_userDefinedRole1') },
        { code: 'userDefinedRole2', name: this.$t('CargoMsg.Cargo_userDefinedRole2') },
        { code: 'userDefinedRole3', name: this.$t('CargoMsg.Cargo_userDefinedRole3') },
        { code: 'userDefinedRole4', name: this.$t('CargoMsg.Cargo_userDefinedRole4') },
        { code: 'userDefinedRole5', name: this.$t('CargoMsg.Cargo_userDefinedRole5') },
        { code: 'userDefinedRole6', name: this.$t('CargoMsg.Cargo_userDefinedRole6') },
        { code: 'userDefinedRole7', name: this.$t('CargoMsg.Cargo_userDefinedRole7') },
        { code: 'overseaOp', name: this.$t('CargoMsg.Cargo_CustomerServiceOverSea') },
        { code: 'siteOp', name: this.$t('SeaExport.FieldOperation') },
        { code: 'doc', name: this.$t('CargoMsg.Cargo_Documents') },
        { code: 'csr', name: this.$t('CargoMsg.Cargo_CustomerService') },
        { code: 'op', name: this.$t('Message.Operation') },
        { code: this.isSea ? 'seaLine' : (this.isAir ? 'airline' : 'railwayLine'), name: this.$t('CargoMsg.Cargo_AirlinePerson') } // 区分海运/空运/铁路
      ]
    }
  },
  created() {
    this.officeList = getFilterCacheList(TYPE_NAMES.basic_data_Office_All, p => p.officeId !== 1)
    /* 海运关联航线 */
    const seaportList = getCacheListByKey(TYPE_NAMES.basic_data_Seaport)
    const seaRegionCodeSet = new Set()
    for (const seaport of seaportList) {
      if (seaport.region) {
        seaRegionCodeSet.add(seaport.region)
      }
    }
    this.seaRegionList = getFilterCacheList(TYPE_NAMES.basic_data_Region, p => seaRegionCodeSet.has(p.code))
    /* 空运关联航线 */
    const airportList = getCacheListByKey(TYPE_NAMES.basic_data_Airport)
    const airRegionCodeSet = new Set()
    for (const airport of airportList) {
      if (airport.region) {
        airRegionCodeSet.add(airport.region)
      }
    }
    this.airRegionList = getFilterCacheList(TYPE_NAMES.basic_data_Region, p => airRegionCodeSet.has(p.code))
  },
  methods: {
    onUserIdChange(value) {
      this.saveData.userId = value
      this.onRelatedPrivilegeChange()
    },
    async onShow(data) {
      if (!data) {
        return
      }
      this.saveData.uuid = data.uuid
      this.saveData.userId = data.userId
      this.ddlLobChangeHandler(data.lob)
      this.saveData.operateType = data.operateType
      if (data.operateType) {
        const array = data.operateType.split(',')
        const list = []
        for (const d of array) {
          if (data.lob === 'AE' || data.lob === 'AI') {
            list.push(Number(d))
          } else {
            list.push(d)
          }
        }
        this.saveData.operateTypeList = list
      }
      if (this.isSea || this.isAir) {
        this.onMultipleRegionChange({ value: this.toArray(data.multipleRegion) })
      } else {
        this.saveData.multipleRegion = data.multipleRegion
      }
      this.saveData.multipleLoadingPortCode = data.multipleLoadingPortCode
      if (this.saveData.multipleLoadingPortCode && (this.isSea || this.isAir)) {
        const portCodeList = this.saveData.multipleLoadingPortCode.split(',')
        for (const portCode of portCodeList) {
          const index = this.portList.findIndex(p => p.code === portCode)
          if (index < 0) {
            let port = null
            if (this.isSea) {
              port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', portCode)
            } else {
              port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', portCode)
            }
            if (port) {
              this.portList.push(port)
            }
          }
        }
      }
      this.saveData.code = data.code
      if (this.saveData.code && (this.isSea || this.isAir)) {
        const portCodeList = this.saveData.code.split(',')
        for (const portCode of portCodeList) {
          const index = this.portList.findIndex(p => p.code === portCode)
          if (index < 0) {
            let port = null
            if (this.isSea) {
              port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', portCode)
            } else {
              port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', portCode)
            }
            if (port) {
              this.portList.push(port)
            }
          }
        }
      }
      this.saveData.multipleCustomJobType = data.multipleCustomJobType
      this.saveData.multipleOpOffice = data.multipleOpOffice
      this.saveData.relatedPrivilege = data.relatedPrivilege
      this.saveData.multipleCargoType = data.multipleCargoType
      this.saveData.multipleCarrierId = data.multipleCarrierId
      this.saveData.multipleConsigneeIdList = []
      if (data.multipleConsigneeId) {
        const multipleConsigneeId = data.multipleConsigneeId.split(',')
        for (const data of multipleConsigneeId) {
          if (data) {
            this.saveData.multipleConsigneeIdList.push(Number(data))
          }
        }
      }
      this.saveData.multipleCargoSource = data.multipleCargoSource
      this.saveData.multipleDestinationAgentList = []
      if (data.multipleDestinationAgent) {
        const multipleDestinationAgent = data.multipleDestinationAgent.split(',')
        for (const data of multipleDestinationAgent) {
          if (data) {
            this.saveData.multipleDestinationAgentList.push(Number(data))
          }
        }
      }
      await this.onRelatedPrivilegeChange()
      this.saveData.multipleRole = data.multipleRole
      if (this.saveData.multipleRole) {
        const positionStrs = data.multipleRole.split(',')
        for (const positionStr of positionStrs) {
          const items = positionStr.split('-')
          this.positionData.push({ value: items[0], isDefault: items[1] === '1' })
        }
        for (const position of this.positionData) {
          const index = this.roleList.findIndex(p => p.code === position.value)
          if (index < 0) {
            const roleObj = this.allRole.find(p => p.code === position.value)
            if (roleObj) {
              this.roleList.push(roleObj)
            }
          }
        }
      } else {
        this.positionData.push({ value: '', isDefault: false })
      }
    },
    ddlLobChangeHandler(result) {
      this.saveData.lob = result
      this.operateTypeList = []
      this.saveData.operateTypeList = []
      switch (result) {
        case 'SE':
        case 'RE':
        case 'RI':
          this.operateTypeList = Array.from(SeaExportConstants.CONTAINER_LOAD_TYPES)
          break
        case 'SI':
          this.operateTypeList = ImportConstants._cargoTypeInputList
          break
        case 'AE':
          this.operateTypeList = AirExportConstants.BUSINESS_MODELS
          break
        case 'AI':
          this.operateTypeList = AirExportConstants.BUSINESS_MODELS
          break
      }
      if (!['SE', 'AE'].includes(this.saveData.lob)) {
        this.saveData.multipleDestinationAgentList = []
      }
      this.saveData.multipleCustomJobType = ''
      this.saveData.multipleCargoType = ''
      if (this.isSea || this.isAir) {
        this.onMultipleRegionChange({ value: [] })
      } else {
        this.saveData.multipleRegion = ''
        this.saveData.multipleLoadingPortCode = ''
        this.saveData.code = ''
      }
      this.saveData.multipleCarrierId = ''
    },
    onOperateTypeChange() {
      if (this.saveData.lob === 'IE') {
        if (!this.saveData.operateTypeList.includes('IC')) {
          this.saveData.multipleCarrierId = ''
        }
      }
    },
    onSave() {
      if (!this.saveData.multipleOpOffice) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOpBranch'))
        return
      }
      // if (!this.saveData.multipleRegion) {
      //   this.$message.warning(this.$t('AirExport.PleaseChooseAnAirline'))
      //   return
      // }
      if (this.saveData.userId === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOperator'))
        return
      }
      const positionStrs = []
      for (const position of this.positionData) {
        if (position.value) {
          positionStrs.push(position.value + (position.isDefault ? '-1' : ''))
        }
      }
      if (positionStrs.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.SelectResponsiblePosition'))
        return
      }
      this.saveData.multipleRole = positionStrs.join(',')
      this.$confirm(this.$t('SystemMaintenance.ConfirmSaveModifiedInfo'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.doSave()
      }).catch(() => {})
    },
    async doSave() {
      if (this.saveData.operateTypeList) {
        let text = ''
        for (const data of this.saveData.operateTypeList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        this.saveData.operateType = text
      } else {
        this.saveData.operateType = ''
      }
      const form = {
        uuid: this.saveData.uuid,
        code: this.saveData.code,
        userId: this.saveData.userId,
        lob: this.saveData.lob,
        operateType: this.saveData.operateType,
        multipleRegion: this.saveData.multipleRegion,
        multipleCustomJobType: this.saveData.multipleCustomJobType,
        relatedPrivilege: this.saveData.relatedPrivilege,
        multipleRole: this.saveData.multipleRole,
        multipleOpOffice: this.saveData.multipleOpOffice,
        multipleLoadingPortCode: this.saveData.multipleLoadingPortCode,
        multipleCargoType: this.saveData.multipleCargoType,
        multipleCarrierId: this.saveData.multipleCarrierId,
        multipleConsigneeIdList: this.saveData.multipleConsigneeIdList,
        multipleCargoSource: this.saveData.multipleCargoSource,
        multipleDestinationAgentList: this.saveData.multipleDestinationAgentList
      }
      const loading = getLoading4Cxt(this.$refs.dialog)
      const res = await onSaveFunc(form).finally(() => {
        loading.close()
      })
      if (res.data.repeat) {
        this.$message.warning(this.$t('SystemMaintenance.UserHasRepeatConfigData'))
        return
      }
      if (res.data.roleDefaultRepeat) {
        this.$confirm(this.$t('SystemMaintenance.UserRoleDefaultRepeat'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const loading2 = getLoading4Cxt(this.$refs.dialog)
          onSaveFunc({ ...form, overRoleDefaultUser: true }).then(res => {
            this.clearFrom()
            this.$emit('saveSuccessHandler', res.data.entity)
          }).finally(() => {
            loading2.close()
          })
        }).catch(() => {})
        return
      }
      this.clearFrom()
      this.$emit('saveSuccessHandler', res.data.entity)
    },
    clearFrom() {
      this.saveData.code = ''
      this.saveData.userId = 0
      this.saveData.lob = ''
      this.saveData.operateTypeList = []
      this.saveData.operateType = ''
      this.saveData.multipleRegion = ''
      this.saveData.multipleCustomJobType = ''
      this.saveData.relatedPrivilege = false
      this.saveData.multipleRole = ''
      this.saveData.multipleOpOffice = ''
      this.saveData.multipleLoadingPortCode = ''
      this.saveData.multipleCargoType = ''
      this.saveData.multipleCarrierId = ''
      this.saveData.multipleConsigneeId = ''
      this.saveData.multipleConsigneeIdList = []
      this.saveData.multipleCargoSource = ''
      this.saveData.multipleDestinationAgent = ''
      this.saveData.multipleDestinationAgentList = []
      this.positionData = []
    },
    removeHandler() {
      this.clearFrom()
      this.$emit('cancelHandler')
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    onMultipleRegionChange(data) {
      this.saveData.multipleRegion = this.toTxt(data.value)
      // if (this.saveData.multipleRegion) {
      const regionList = this.saveData.multipleRegion ? this.saveData.multipleRegion.split(',') : []
      if (this.isSea) {
        this.portList = getFilterCacheList(TYPE_NAMES.basic_data_Seaport, p => regionList.length === 0 || regionList.includes(p.region))
      } else {
        this.portList = getFilterCacheList(TYPE_NAMES.basic_data_Airport, p => regionList.length === 0 || regionList.includes(p.region))
      }
      if (this.saveData.multipleLoadingPortCode) {
        const portCodeList = this.saveData.multipleLoadingPortCode.split(',')
        const newPortCodeList = []
        for (const port of this.portList) {
          if (portCodeList.includes(port.code)) {
            newPortCodeList.push(port.code)
          }
        }
        this.saveData.multipleLoadingPortCode = this.toTxt(newPortCodeList)
      }
      if (this.saveData.code) {
        const portCodeList = this.saveData.code.split(',')
        const newPortCodeList = []
        for (const port of this.portList) {
          if (portCodeList.includes(port.code)) {
            newPortCodeList.push(port.code)
          }
        }
        this.saveData.code = this.toTxt(newPortCodeList)
      }
      // } else {
      //   this.portList = []
      //   this.saveData.multipleLoadingPortCode = ''
      //   this.saveData.code = ''
      // }
    },
    async onRelatedPrivilegeChange() {
      if (this.saveData.relatedPrivilege) {
        if (this.saveData.userId > 0) {
          const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', this.saveData.userId)
          if (user.type === 1 || user.type === 2) { // 管理员，可以看到所有
            this.roleList = this.allRole
          } else {
            if (this.saveData.multipleOpOffice) {
              const res = await checkUserPrivilege({
                userId: this.saveData.userId,
                category: 'role',
                shapes: 'userDefinedRole1,userDefinedRole2,userDefinedRole3,userDefinedRole4,userDefinedRole5,userDefinedRole6,userDefinedRole7,overseaOp,siteOp,doc,csr,op,seaLine,airline,railwayLine',
                officeIds: this.saveData.multipleOpOffice
              })
              const userPrivileges = Array.from(res.data, p => p.toUpperCase())
              this.roleList = this.allRole.filter(p => userPrivileges.includes(p.code.toUpperCase()))
            } else {
              this.roleLis = []
            }
          }
        } else {
          this.roleLis = []
        }
      } else {
        this.roleList = this.allRole
      }
      this.matchPositionData()
    },
    matchPositionData() {
      if (this.isSea) {
        const line = this.positionData.find(p => p.value === 'airline' || p.value === 'railwayLine')
        if (line) {
          line.value = 'seaLine'
        }
      } else if (this.isAir) {
        const line = this.positionData.find(p => p.value === 'seaLine' || p.value === 'railwayLine')
        if (line) {
          line.value = 'airline'
        }
      } else {
        const line = this.positionData.find(p => p.value === 'seaLine' || p.value === 'airline')
        if (line) {
          line.value = 'railwayLine'
        }
      }
      for (const position of this.positionData) {
        const index = this.roleList.findIndex(p => p.code === position.value)
        if (index < 0) {
          position.value = ''
        }
      }
    },
    onPositionChange(position) {
      if (!position.value) {
        return
      }
      for (const item of this.positionData) {
        if (!item.value || item === position) {
          continue
        }
        if (item.value === position.value) {
          position.value = ''
          this.$message.warning(this.$t('SystemMaintenance.PositionCannotDuplicated'))
          break
        }
      }
    },
    onAddPosition() {
      this.positionData.push({ value: '', isDefault: false })
    },
    onRemovePosition(position) {
      this.positionData = this.positionData.filter(p => p !== position)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/styles/element-variables.scss";
#app .add-user-port-window::v-deep {
  .el-dialog__body {
    padding: 10px 20px 30px 20px;
    .flex-column {
      display: flex;
      flex-direction: column;
    }
    .title {
      display: inline-block;
      position: relative;
      font-size: 13px;
      padding-left: 15px;
      line-height: 14px;
      margin-bottom: 10px;
    }
    .title:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #1F75D5;
    }
    .form-operator {
      margin-left: 5px;
      margin-right: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus {
        font-size: medium;
        color: $--color-success;
      }
      .el-icon-remove {
        font-size: medium;
        color: $--color-danger;
      }
    }
  }
}
</style>
